module.exports = __webpack_public_path__ + "static/img/paixu01.0b17d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/paixu01.png
// module id = 113
// module chunks = 0